import React from 'react';
import { Link, SxProps, Theme } from '@mui/material';
import { useSelector } from 'react-redux';
import { useModal } from 'hooks';
import usePlatform from 'hooks/usePlatform';
import { routes } from 'utils/routing';
import { CreatingOrderSelectors } from 'store/selectors';
import DocumentModal from 'components/modals/DocumentModal';

type DocumentType = 'terms' | 'privacy';

interface IProps {
  document: DocumentType;
  children?: React.ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
}

const DocumentLink: React.FC<IProps> = ({ document, children, className, sx }) => {
  const platform = usePlatform();
  // Same fallback as EventInfo/EventOrganization: `?platform=` doesn't survive most in-checkout
  // navigations, so the Redux flag (stable across the whole flow) backs it up.
  const isEmbeddedCart = useSelector(CreatingOrderSelectors.getIsEmbedded);
  const [showDocument] = useModal(DocumentModal);

  if (platform || isEmbeddedCart) {
    return (
      <Link component="button" type="button" className={className} sx={sx} onClick={() => showDocument({ document })}>
        {children}
      </Link>
    );
  }

  const route = document === 'terms' ? routes.termsOfUse() : routes.privacyPolicy();

  return (
    <Link href={route.link} target="_blank" className={className} sx={sx}>
      {children}
    </Link>
  );
};

export default DocumentLink;
